import { useParams } from "react-router-dom";
import useProduct from "./useProduct";
import useCourse from "./useCourse";
import UserContext from "../../../services/Context/UserContext";
import { useContext } from "react";

export default function useTargetUrl() {

    const { user } = useContext(UserContext);

    const { id } = useParams();

    const course = useCourse();

    const product = useProduct();

    if (course?.free) return `/courses/${id}/free`;

    if (!product) return `/courses/${id}/enroll`;

    if (product?.variant?.id === 'etudiant' && !user?.proofVerifiedAt) return `/courses/${id}/etudiant`;

    if (['dpc','dpc-pi'].includes(product?.variant?.id)) return `/courses/${id}/dpc/${product?.reference2 || 'pending'}`;

    if (product?.variant?.id === 'opco') return `/courses/${id}/opco`;

    return `/products/${product?.id}/order`;
}